import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';

import './SortableSubCollection.css';

const SortableSubCollectionList = SortableContainer(({ children }) => (
    <div className="sortable-subcollection-list">{children}</div>
));

export default SortableSubCollectionList;
